import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { LanguageService } from '@whbabtec-services';
import { WHBABTEC_LANGS, WhbabtecLanguages } from '@whbabtec-types';

@Injectable({
  providedIn: 'root',
})
export class LanguageGuard {
  constructor(
    private router: Router,
    private languageService: LanguageService
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const lang = route.params['lang'] as WhbabtecLanguages;
    if (WHBABTEC_LANGS.some((l) => l === lang)) {
      this.languageService.syncLanguage(lang);
      return true;
    }
    this.router.navigate(['']);
    return false;
  }
}
